export function throwError(message: string) {
  throw new Error(message);
}
